<template>
  <AdministrationHeader>
    <GroupTable />
  </AdministrationHeader>
</template>

<script>
import AdministrationHeader from "@/administration/components/AdministrationHeader.vue";
import GroupTable from "@/administration/components/tables/GroupTable.vue";

export default {
  name: 'AdministrationGroupsView',
  components: {AdministrationHeader, GroupTable},
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY
  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
